import React from 'react';

import {
  Title,
  Paper,
  Stack,
  Group,
  Button
} from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useNavigate } from 'react-router-dom';

import SurveyForm from '../components/survey/SurveyForm';

const AddSurvey: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    void navigate('/surveys');
    notifications.show({
      title: 'Success',
      message: 'Survey created successfully',
      color: 'green'
    });
  };

  const handleCancel = () => {
    void navigate('/surveys');
  };

  return (
    <Stack gap="md">
      <Group align="center" justify="space-between">
        <Title order={1}>Add New Survey</Title>
        <Button variant="outline" onClick={() => void navigate('/surveys')}>
          Back to All Surveys
        </Button>
      </Group>

      <Paper withBorder p="xl">
        <Stack gap="lg">
          <SurveyForm
            mode="add"
            onCancel={handleCancel}
            onSuccess={handleSuccess}
          />
        </Stack>
      </Paper>
    </Stack>
  );
};

export default AddSurvey;

